import { useForm } from '@sayyesschool/frontend/hooks/form';
import Form from '@sayyesschool/frontend/ui-components/form';

const defaultLesson = {
    title: ''
};

export default function LessonForm({ lesson = defaultLesson, onSubmit, ...props }) {
    const { data, handleChange, handleSubmit } = useForm({
        values: {
            'title*': lesson.title
        },
        onSubmit
    }, [lesson.updatedAt]);

    return (
        <Form
            className="LessonForm"
            noValidate
            onSubmit={handleSubmit}
            {...props}
        >
            <Form.Input
                {...data.title}
                label="Название"
                onChange={handleChange}
            />
        </Form>
    );
}